export default {
  user: undefined,
  users: {}
}
